// @flow

import React from 'react'
import {merge} from 'ramda'

type Props = {
  height: number,
  children: any,
}

const style = {
  overflowY: 'scroll',
}

const mergeHeight = (h) => merge(style, {height: h > 0 ? h : 'auto', overflowY: h > 0 ? 'scroll' : 'auto'})

export const RawOverflow = ({children, height}: Props) =>
  <div style={mergeHeight(height)}>
    {children}
  </div>

export default RawOverflow



// WEBPACK FOOTER //
// ./src/elements/overflow.js